module.exports = __webpack_public_path__ + "img/hair.0df802e0.svg";